import React, { Fragment, useState } from 'react';
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import Typography from '@mui/material/Typography'
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { actualizarRelacionesCliente, agregarRelacionesCliente } from '../../../../redux/DucksAtencionACliente/ModuloConsultaDucks';
import { useDispatch, useSelector } from 'react-redux'
import Button from '@mui/material/Button';
import { ThemeProvider, createTheme } from '@mui/material/styles';

function ModalRelacionesComponet(props) {

  const dispatch = useDispatch()
  let marcas = props?.marcas
  let tipoRelacion = props?.tipoRelacion

  const [openModalAlerta, setOpenModalAlerta] = React.useState(false);
  const handleOpenModalAlerta = () => { setOpenModalAlerta(true) }
  const handleCloseModalAlerta = () => { setOpenModalAlerta(false) }

  const [openModalReporte, setOpenModal] = React.useState(true);
  const handleCloseModal = () => {
    setOpenModal(false)
    props?.setOpenModal()
    props?.setTipoRelacion('')
    props?.setEditar(false)
  }
  const [numeroSocio, setNumeroSocio] = React.useState(props?.editar ? props?.tipoRelacion == 'PRODUCTOR' ? props?.dataEditar?.productor : props?.tipoRelacion == 'MAQUILADOR' ? props?.dataEditar?.envasado : '' : '');
  const [marca, setMarca] = React.useState(props?.editar ? props?.dataEditar?.marca : '');

  const guardarRelacion = async () => {
    if (numeroSocio == '' && marca == '') {
      handleOpenModalAlerta()
    } else {
      if (!props?.editar) {
        let data = {}
        if (tipoRelacion == 'PRODUCTOR') data = { idcliente: props?.detalleCliente.idcliente, productor: numeroSocio, marca: marca, numerosocio: props?.detalleCliente.numerosocio }
        if (tipoRelacion == 'MAQUILADOR') data = { idcliente: props?.detalleCliente.idcliente, envasado: numeroSocio, marca: marca, numerosocio: props?.detalleCliente.numerosocio }
        await dispatch(agregarRelacionesCliente(data))
      } else {
        let data = {}
        if (tipoRelacion == 'PRODUCTOR') data = {
          idcliente: props?.detalleCliente.idcliente, productor: numeroSocio, marca: marca,
          numerosocio: props?.detalleCliente.numerosocio, idrelacionclientes: props?.dataEditar?.idrelacionclientes
        }
        if (tipoRelacion == 'MAQUILADOR') data = {
          idcliente: props?.detalleCliente.idcliente, envasado: numeroSocio, marca: marca,
          numerosocio: props?.detalleCliente.numerosocio, idrelacionclientes: props?.dataEditar?.idrelacionclientes
        }
        await dispatch(actualizarRelacionesCliente(data))
      }
      setOpenModal(false)
      props?.setOpenModal(false)
      props?.setTipoRelacion('')
      props?.setEditar(false)
    }
  }

  const modalAlerta = () => {
    return (
      <div>
        <Modal open={openModalAlerta} onClose={handleCloseModalAlerta} aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description">
          <Box sx={styleAlerta}>
            <Typography id="modal-modal-description" component="h2" sx={{ mt: 0, fontFamily: 'Montserrat' }} className='text-center'>
              <h3 className='text-center'><b>¡ALERTA!</b></h3>
              <p className='mt-3'>Existen campos vacíos.</p>
            </Typography>
            <br />
            <ThemeProvider theme={theme}>
              <Button variant="contained" color="primary" style={{ width: '100%', margin: 'auto' }} onClick={() => { handleCloseModalAlerta() }}>Aceptar</Button>
            </ThemeProvider>
          </Box>
        </Modal>
      </div>
    )
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    height: 'fit-content',
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
    p: 4,
    borderRadius: '5px'
  };

  const styleAlerta = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 300,
    height: 'fit-content',
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
    p: 4,
    borderRadius: '5px'
  };

  const theme = createTheme({
    palette: {
      primary: {
        main: "#EDB75A"
      },
      secondary: {
        main: "#DC3545"
      }
    },
    typography: {
      fontFamily: "Montserrat",
      textTransform: 'none',
      button: {
        fontSize: 16,
        fontWeight: 500,
        fontFamily: "Montserrat",
        textTransform: 'none'
      }
    }
  });

  return (
    <Fragment>
      <Modal
        open={openModalReporte} onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ThemeProvider theme={theme}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 `} style={{ textAlign: 'center' }}>
                <h3><strong>{props?.editar ? 'EDITAR ' : 'AGREGAR '} {tipoRelacion}</strong></h3>
              </div>
            </Typography>
            <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} style={{ color: "black", textAlign: 'justify', fontFamily: 'Montserrat' }}>
              <div className='row mt-2 mb-3'>
                <div className="col-12 col-md-12 mt-3 mb-4 text-start">
                  <TextField id="outlined-basic" label='Número de socio' variant="outlined" InputLabelProps={{ shrink: true }} hiddenLabel style={{ width: '100%' }}
                    value={numeroSocio} onChange={e => setNumeroSocio(e.target.value)} />
                </div>
                <Autocomplete id="free-solo-demo" freeSolo
                  value={marca}
                  onInputChange={(e, value) => { setMarca(value) }} options={marcas?.map((option) => option)} style={{ width: '100%' }}
                  getOptionLabel={(option) => (typeof option === 'string' ? option : option.marca)}
                  renderInput={(params) => <TextField {...params} label="Marca" InputLabelProps={{ shrink: true }} />} />
              </div>
            </Typography>
            <br />

            <div className='row'>
              <div className='col-6 col-md-6'>
                <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => { handleCloseModal() }}>Cancelar</Button>
              </div>
              <div className='col-6 col-md-6'>
                <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => { guardarRelacion() }}>Guardar</Button>
              </div>
            </div>
          </ThemeProvider>
        </Box>
      </Modal>
      {modalAlerta()}
    </Fragment>
  );
}

export default ModalRelacionesComponet;